import React from 'react'

import { ButtonType } from 'src/apollo/sites'
import { t } from 'src/translations/src'

import Button from 'shared/components/common/button'

import { useSelectedLocale } from './common'

interface LocaleSelectorButtonProps {
  onClick: () => void
  iconColor?: string
}

/**
 * LocaleSelectorButton is a complete button component that displays the currently
 * selected locale ISO code and triggers the locale selection modal when clicked.
 */
export function LocaleSelectorButton({
  onClick,
  iconColor
}: LocaleSelectorButtonProps) {
  const { selectedLocale } = useSelectedLocale()

  if (!selectedLocale) {
    return null // Return nothing when client not ready
  }

  return (
    <Button
      variant={ButtonType.Text}
      tabIndex={0}
      style={{
        padding: '0px',
        display: 'flex',
        alignItems: 'center',
        color: iconColor
      }}
      aria-label={t('locale-selector.aria-label')}
      onClick={onClick}
      data-testid='locale-selector'
    >
      <div
        data-testid='locale-selector-button'
        className='localeSelector buttonContent'
      >
        <span>{selectedLocale.isoCode}</span>
      </div>
    </Button>
  )
}
